
import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ValidationMessageComponent } from '../validation-message/validation-message.component';

@Component({
  selector: 'csl-validation-messages',
  standalone: true,
  imports: [],
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block text-xs text-[--input-validation-message-color] *:mt-1.5',
  },
})
export class ValidationMessagesComponent implements AfterContentInit {
  private _errors: ValidationErrors | null = null;
  private _requiredErrorName = 'required';

  @Input({ required: true })
  public set errors(value: ValidationErrors | null) {
    this._errors = value;
    this.showErrors();
  }

  @ContentChildren(ValidationMessageComponent) messages: ValidationMessageComponent[] = [];

  ngAfterContentInit(): void {
    this.showErrors();
  }

  showErrors() {
    if (!this.messages) return;

    this.messages.forEach((message) => (message.show = false));

    if (!this._errors) return;

    const visible = this.messages.filter((message) => message.name in this._errors!);

    const requiredError = visible.find((message) => message.name === this._requiredErrorName);

    if (requiredError) {
      requiredError.show = true; // if required error is present, show only it
    } else {
      visible.forEach((message) => (message.show = true));
    }
  }
}
